<div class="menu-buttons-content">
  <a *ngFor="let a of topActions">
    <square-button [label]="a.label" [labelSuffix]="a.labelSuffix" [disabled]="isDisabled(a.disabled)"
                   (click)="onActionClick(a, $event)" [testId]="a.id"></square-button>
  </a>
</div>
